import { computed } from 'vue'
import { tagColors } from '@/core/colors'
/* eslint-disable-next-line */
export const parseDate = (value, format) => computed(() => {
  const month = new Date(value).toLocaleString('en-US', {
    month: 'short',
    timeZone: 'UTC'
  })
  const day = new Date(value).toLocaleString('en-US', {
    day: 'numeric'
  })
  const year = new Date(value).toLocaleString('en-US', {
    year: 'numeric',
    timeZone: 'UTC'
  })
  const hour = new Date(value).toLocaleString('en-US', {
    hour12: false,
    hour: 'numeric'
  })
  const minute = new Date(value).toLocaleString('en-US', {
    minute: 'numeric',
    timeZone: 'UTC'
  })

  if (format === 'DD-MM-YYYY hh:mm') {
    return `${day} ${month}, ${year} ${hour}:${minute.length === 1 ? `0${minute}` : minute}`
  } else if (format === 'hh:mm') {
    return `${hour}:${minute.length === 1 ? `0${minute}` : minute}`
  } else if (format === 'MM-DD-YYYY hh:mm') {
    return `${month} ${day} ${year}, ${hour}:${minute.length === 1 ? `0${minute}` : minute}`
  } else if (format === 'MM-YYYY') {
    return `${month} ${year}`
  } else if (format === 'DD-MM,YYYY') {
    return `${day} ${month.toLowerCase()}, ${year}`
  } else if (format === 'DD-MM-YYYY') {
    return `${day} ${month.toLowerCase()} ${year}`
  } else if (format === 'lastUpdate') {
    const currentMonth = new Date().toLocaleString('en-US', {
      month: 'short',
      timeZone: 'UTC'
    })

    const currentDate = new Date().toLocaleString('en-US', {
      day: 'numeric',
      timeZone: 'UTC'
    })

    if (currentMonth === month) {
      if (currentDate - day === 1) {
        return 'Yesterday'
      } else if (currentDate - day > 1) {
        return `${month} ${day}, ${hour}:${minute.length === 1 ? `0${minute}` : minute}`
      } else {
        return `${hour}:${minute.length === 1 ? `0${minute}` : minute}`
      }
    }

    return `${month} ${day} ${year}`
  } else if (format === 'notification') {
    const currentDate = new Date().toLocaleString('en-US', {
      day: 'numeric'
    })
    if (day - currentDate === 1) {
      return `tomorrow at ${hour}:${minute.length === 1 ? `0${minute}` : minute}`
    } else {
      return `${hour}:${minute.length === 1 ? `0${minute}` : minute}`
    }
  }
}).value

export const tagColor = (value) => computed(() => {
  const defaultColor = { main: '#FFDE88', text: '#634700' }
  const color = tagColors[value] || defaultColor

  return `background-color: ${color.main}; color: ${color.text}`
}).value

export const currency = (value, currency) => computed(() => {
  if (Number.isNaN(value)) {
    return value
  }

  const currencyFormatter = new Intl.NumberFormat('en', {
    currency: currency || 'usd',
    style: 'currency',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  })

  return currencyFormatter.format(value)
}).value
